import { logEvent } from 'commons/utils/tracking';
import {
  SETTINGS_EXTERNALCODES_GOOGLE_GA4TOKEN_AUTHORIZE_ATTEMPT,
  MENU_SETTINGS_EXTERNALCODES_VIEW,
  MENU_SECONDARY_PREFERENCES_ADVANCED_CLICK,
} from 'config/trackingEvents';

export const menuSecondaryExternalCodesClick = () => {
  logEvent(MENU_SECONDARY_PREFERENCES_ADVANCED_CLICK, {});
};

export const menuSettingsExternalCodesView = (
  gtmLinked: boolean,
  ga4Linked: boolean,
  ga4ConsentGiven: boolean,
) => {
  logEvent(MENU_SETTINGS_EXTERNALCODES_VIEW, {
    gtm_linked: gtmLinked ? 'true' : 'false',
    ga4_linked: ga4Linked ? 'true' : 'false',
    ga4_token: ga4ConsentGiven ? 'authorized' : 'non-authorized',
  });
};

export const ga4ConsentButtonClick = (measurementId: string) => {
  logEvent(SETTINGS_EXTERNALCODES_GOOGLE_GA4TOKEN_AUTHORIZE_ATTEMPT, {
    measurement_id: measurementId,
  });
};
